<template>
  <div>
    <label v-if="label" class="form-label">{{ label }}:</label>
    <div class="form-input p-0" :class="{ error: error }">
      <div class="flex items-center justify-between p-2">
        <a class="px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm"  :href="route('files.download', {path: modelValue})" download>Shkarko</a>
        <button type="button" class="px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm" @click="change">Fshij</button>

      </div>

    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String,
    label: String,
    accept: String,
    error: String,
  },
  emits: ['update:modelValue'],
  methods: {
    change(e) {
      this.$emit('update:modelValue', null)
    },
  },
}
</script>
